var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "slotBar"
  }, [_c('div', {
    staticClass: "flex justify-center items-center gap"
  }, [_vm._l(_vm.tiles, function (tile) {
    return _c('SheepTileComponent', {
      key: tile.id,
      attrs: {
        "tile": tile,
        "inSlot": true
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.handleTileClick(tile);
        }
      }
    });
  }), _vm._l(_vm.emptySlotCount, function (i) {
    return _c('div', {
      key: `empty-${i}`,
      staticClass: "empty-tile"
    });
  })], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };